<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('openOrder')}}</h3> 
        </div>
        <div class="mapIco-list-table mt-4">
            <app-open-orders :pageName="'open-order'"></app-open-orders>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import openOrders from '../shared/tradingAccounts/open_orders_listing'
    export default {
        name: 'Open-Orders',
        mixins: [fxViewMixins],
        data() {
            return {
            }
        },
        components: {
            appOpenOrders: openOrders
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/open_orders_listing.vue